import React from "react";
import PropTypes from "prop-types";
import ErrorBoundary from "../error_boundary";
import GetQwotedCTA from "../profiles/GetQwotedCTA";
import CompanyShow from "./show";
import { CompanyContextProvider } from "./data/company_context_management";

function CompanyTopLevelShow({
  companyId,
  userId = undefined,
  viewerContext = undefined,
  subtype = undefined,
  displayStylePreference = undefined,
}) {
  // companySeed lets the provider derive displayType before the fetch resolves, so the loading
  // skeleton collapses the rail exactly like the loaded page will (no reflow). Raw server values
  // only — the displayType derivation stays single-sourced in the provider.
  const contextValue = { companyId, userId, viewerContext, companySeed: { subtype, displayStylePreference } };

  return (
    <CompanyContextProvider value={contextValue}>
      <ErrorBoundary>
        <CompanyShow companyId={companyId} userId={userId} />
      </ErrorBoundary>
      {!viewerContext?.isAuthenticated && <GetQwotedCTA />}
    </CompanyContextProvider>
  );
}

CompanyTopLevelShow.propTypes = {
  companyId: PropTypes.string.isRequired,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  viewerContext: PropTypes.shape({
    editable: PropTypes.bool,
    isSelf: PropTypes.bool,
    isAuthenticated: PropTypes.bool,
    role: PropTypes.string,
  }),
  subtype: PropTypes.string,
  displayStylePreference: PropTypes.string,
};

export default CompanyTopLevelShow;
